import {
    MODAL_HIDE, MODAL_TYPE_SUCCESS, MODAL_SHOW, MODAL_TYPE_CALL_ME, MODAL_TYPE_FNOL_CALL_ME, MODAL_TYPE_SEND_OTP, MODAL_TYPE_VERIFY_OTP, MODAL_TYPE_ERROR,
    MODAL_TYPE_LINK_POLICY, MODAL_DONATE, MODAL_THANK_YOU, SET_CUSTOMER_DATA, LOADING_SCREEN_SHOW, LOADING_SCREEN_HIDE,
    MODAL_TYPE_UPDATE_PROFILE, FIELD_PREFERREDLANGUAGE, MODAL_TYPE_REQUEST_DOCS, MODAL_TYPE_REFER_A_FRIEND, MODAL_TYPE_OK,
    MODAL_TYPE_COMING_SOON,
    DOC_CONFIRMATION_OF_COVER,
    MODAL_TYPE_REQUEST_DOCS_COVER_DATE,
    DOC_TAX_INVOICE,
    MODAL_TYPE_REQUEST_DOCS_DATE,
    MODAL_TYPE_REQUEST_DOCS_COVER,
    DOC_CROSS_BORDER_LETTER,
    MODAL_TYPE_BROKER_DOCS,
    MODAL_TYPE_ADD_VAP,
    MODAL_TYPE_ADD_ACCESSORRY,
    MODAL_TYPE_ADD_VAP_CAR_HIRE,
    MODAL_TYPE_ADD_CREDIT_SHORTFALL,
    MODAL_TYPE_INTERVENTION,
    MODAL_TYPE_QUOTE_PAYMENT,
    MODAL_TYPE_ADD_NEW_QUOTE_ITEM,
    MODAL_TYPE_REMOVE_QUOTE_ITEM,
    MODAL_TYPE_SHOW_BANKING,
    MODAL_TYPE_SHOW_LEGAL,
    MODAL_TYPE_SHOW_EDIT,
    MODAL_TYPE_QUOTE_ITEM_DISCARD,
    MODAL_TYPE_REQUET_CANCELATION,
    MODAL_TYPE_CANCEL_POLICY_EDIT,
    MODAL_TYPE_ANOTHER_SELF_INSPECTION,
    MODAL_TYPE_SUBMIT_SELF_INSPECTION,
    MODAL_DRIVABLE_NO,
    MODAL_TOW_ASSIST,
    MODAL_TYPE_CHANGE_CREDIT_CARD,
    FNOL_SELECTED_DAMAGE_CAR_SHOW,
    MODAL_SWITCH_TO_MOBILE,
    MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE,
    MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE,
    MODAL_TYPE_CLAIM_CONTINUE_SUCCESS,
    MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT,
    FNOL_SELECTED_DAMAGE_MB_SHOW,
    MODAL_TYPE_DUPLICATE_CLAIM,
    MODAL_TAKE_FNOL_PHOTOS,
    MODAL_TYPE_ADD_RAFF_ASSIST,
    MODAL_TYPE_REFER_AGAIN,
    MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE,
    MODAL_TYPE_SMS_SENT,
    MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY,
    MODAL_GET_BACK_TO_YOU,
    MODAL_TYPE_LIFE_REMOVE_BENEFICIARY,
    MODAL_TYPE_CLAIM_ESTIMATED_TIME,
    MODAL_TYPE_REQUEST_A_CAR,
    MODAL_TYPE_REPAIRS_TAKING_LONGER,
    MODAL_TYPE_CLAIM_COST_BREAKDOWN,
    MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK,
    MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE,
    MODAL_TYPE_ESTIMATED_DATE_CHANGED,
    MODAL_TYPE_CLAIM_DISCLAIMER,
    MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS,
    MODAL_TYPE_CALL_BACK_REQUEST,
    MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE,
    MODAL_TYPE_QUOTE_MAINLINE_REMOVAL,
    MODAL_TYPE_QUOTE_SOFT_REJECTED,
    MODAL_TYPE_QUOTE_HARD_REJECTED,
    MODAL_TYPE_SEND_IMEI_NUMBER,
    MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE,
    MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES,
    MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM,
    MODAL_TYPE_POLICY_VIEW_AMENDMENTS,
    MODAL_TYPE_REMOVE_COVER,
    MODAL_TYPE_REMOVE_COVER_COMPLETE,
    MODAL_TYPE_REMOVE_LAST_COVER,
    MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS,
    MODAL_TYPE_SHOW_EDIT_REMOVE,
    MODAL_TYPE_REMOVE_REASONS,
    MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE,
    MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS,
    MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP,
    MODAL_TYPE_VIEW_INSPECTION_PHOTO,
    MODAL_TYPE_VIEW_POLICE_REPORT,
    MODAL_TYPE_VIEW_BLACKLIST_PHONE,
    MODAL_TYPE_NO_LONGER_MAINLINE,
    MODAL_TYPE_CELLPHONE_PLEASE_WAIT,
    MODAL_TYPE_CLICK_AWAY,
    MODAL_FNOL_NOTIFICATION_SUBMIT,
    MODAL_CLEAR_PARTY,
    MODAL_TYPE_CLAIMS_ADDRESS_CHANGE,
    MODAL_SIGN_IN,
    MODAL_REDIRECT_ZA,
    MODAL_REDIRECT_NAM,
    EXISTING_CLIENT_ERROR,
    MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL
} from './../constants/constants';
import { ERROR_HEADER, REFER_A_FRIEND_HEADER, THANKS_FOR_REFERRING_A_FRIEND, ERROR_SOMETHING_WENT_WRONG } from '../constants/copy';
import { postToController, logErrorToDatabase } from './apiActions';
import { IveriSubmission } from './salesActions';
import { logEvent } from '../firebase/firebase';

export const hideModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_SUCCESS,
                visible: false,
            }
        });
    }
}

export const showDrivableNoModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_DRIVABLE_NO,
            }
        });
    }
}

export const showFNOLSubmitModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_FNOL_NOTIFICATION_SUBMIT,
            }
        });
    }
}

export const showSwitchToMobile = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type:MODAL_SWITCH_TO_MOBILE,
            }
        });
    }
}

export const showTowAssistModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TOW_ASSIST,
            }
        });
    }
}

export const showCallMeModal = (showDropDown) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_CALL_ME,
                showDropDown: showDropDown,
            }
        });
    }
}

export const showFnolCallMeModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_FNOL_CALL_ME,
            }
        });
    }
}

export const showRequestOTPModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_LINK_POLICY,
            }
        });
    }
}

export const showVerifyOTPModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_VERIFY_OTP,
            }
        });
    }
}

export const showErrorModal = (error) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ERROR,
                header: ERROR_HEADER,
                body: error,
            }
        });
    }
}

export const showInterventionErrorModal = (error) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_INTERVENTION,
                header: ERROR_HEADER,
                body: error,
            }
        });
    }
}

export const showSoftRejectedModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_QUOTE_SOFT_REJECTED,
            }
        });
    }
}

export const showHardRejectedModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_QUOTE_HARD_REJECTED,
            }
        });
    }
}

export const showLinkPolicyModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_LINK_POLICY,
            }
        });
    }
}

export const showRemoveLifeBeneficiaryModal = (beneficiary, callback) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                beneficiaryName: beneficiary.name,
                callback: callback,
                type: MODAL_TYPE_LIFE_REMOVE_BENEFICIARY,
            }
        });
    }
}

export const showDonateDecrease = (id, name, image) => {
    return (dispatch) => {
        if (id === "411C502B-E56C-442D-A9B7-10741336039D") {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_DONATE,
                    stopDecrease: true,
                    donationId: id,
                }
            });
        }
        else {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_DONATE,
                    donationId: id,
                    charityName: name,
                    charityImage: image,
                }
            });
        }
    }
}

export const donateDecreaseToOrganization = (id, name) => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_monthly_decrease_donate', getState().profile.policyId);
        await postToController(dispatch, 'UpdateMonthlyDecreaseOption',
            JSON.stringify({
                PolicyId: getState().profile.policyId,
                DecreaseOptionId: id,
            })).then(async (response) => {
                if (response === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            visible: true,
                            type: MODAL_THANK_YOU,
                            charityName: name,
                        }
                    });

                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            isDecreaseDonated: true,
                            donationOrganizationId: id,
                        }
                    });
                }
                else {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            isDecreaseDonated: false,
                            donationOrganizationId: id,
                        }
                    });
                }
            }).catch((err) => {
                logErrorToDatabase("Error post donateDecreaseToOrganization, Error: " + err);
            }).finally(() => {
                dispatch({ type: LOADING_SCREEN_HIDE });
            })
    }
}


export const showUpdateCustomerInfo = (field) => {
    return async (dispatch, getState) => {
        await getLanguages(dispatch, getState, field)
    }
}

export const showBrokerPopup = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_BROKER_DOCS,
            }
        });
    }
}

export const showRequestDocuments = (documentName, documentId) => {
    if (documentName === DOC_CONFIRMATION_OF_COVER) {
        return (dispatch) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_TYPE_REQUEST_DOCS_COVER,
                    document: documentName,
                    documentId: documentId
                }
            });
        }
    }
    else if (documentName === DOC_CROSS_BORDER_LETTER) {
        return (dispatch) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_TYPE_REQUEST_DOCS_COVER_DATE,
                    document: documentName,
                    documentId: documentId
                }
            });
        }
    }
    else if (documentName === DOC_TAX_INVOICE) {
        return (dispatch) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_TYPE_REQUEST_DOCS_DATE,
                    document: documentName,
                    documentId: documentId
                }
            });
        }
    }
    else {
        return (dispatch) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_TYPE_REQUEST_DOCS,
                    document: documentName,
                    documentId: documentId
                }
            });
        }
    }
}

async function getLanguages(dispatch, getState, field) {
    switch (field) {
        case FIELD_PREFERREDLANGUAGE:
            await postToController(dispatch, 'GetLanguages', JSON.stringify({ Parameter: 244 })).then(async (response) => {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        visible: true,
                        type: MODAL_TYPE_UPDATE_PROFILE,
                        field: field,
                        languages: response,
                    }
                })
            }).catch((err) => {
                logErrorToDatabase("Error post getLanguages, Error: " + err);
            })
            break;
        default:
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    visible: true,
                    type: MODAL_TYPE_UPDATE_PROFILE,
                    field: field,
                }
            })
    }
}

export const showReferFriend = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REFER_A_FRIEND,
                modalProps: {
                    header: REFER_A_FRIEND_HEADER,
                }
            }
        });
    }
}

export const showPaymentOptions = () => {
    return async (dispatch, getState) => {
        await dispatch(IveriSubmission(getState().sales.quoteId));
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_QUOTE_PAYMENT,
            }
        });
    }
}

export const referAFriend = (name: string, surname: string, number: string) => {
    return async (dispatch, getState) => {
        logEvent('SSP_refer_a_friend', getState().profile.policyId);
        await postToController(dispatch, 'CreateEmployeeLead', JSON.stringify({
            ReferringPolicyId: getState().profile.policyId,
            Name: name,
            Surname: surname,
            MobileNumber: number,
        })).then(async (response) => {

            dispatch({
                type: MODAL_HIDE
            });
            if (response === true) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_REFER_AGAIN,
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const showComingSoon = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_COMING_SOON
            }
        });
    }
}

export const showAddVap = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e)
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_VAP,
                vap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: hadVap.length > 0 ? true : false,
                },
            }
        });
    }
}

export const showAddAccessory = (selectedAccessorry: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_ACCESSORRY,
                accessory: selectedAccessorry,
            }
        });
    }
}

export const showAddCarHire = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e)
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_VAP_CAR_HIRE,
                vap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: (hadVap !== undefined && hadVap.length > 0) ? true : false,
                },
                vapList: getState().sales.carHireOptions,
            }
        })
        
    }
}

export const showTyreAndRim = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e) ?? []
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_VAP_CAR_HIRE,
                vap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: hadVap.length > 0 ? true : false,
                },
                vapList: getState().sales.tyreAndRimOptions,
            }
        })
    }
}

export const showAddLittleDings = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e)
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_VAP_CAR_HIRE,
                vap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: hadVap.length > 0 ? true : false,
                },
                vapList: getState().sales.littleDingsOptions,
            }
        })
    }
}

export const showAddCreditShortfall = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e)
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_CREDIT_SHORTFALL,
                vap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: hadVap.length > 0 ? true : false,
                },
                vapList: getState().sales.balloonOptions,
            }
        })
    }
}

export const showAddRafAssist = (e: any) => {
    return async (dispatch, getState) => {
        let selectedVap = getState().sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        let hadVap = []
        if (getState().sales.isInEdit) {
            hadVap = getState().profile.selectedPersonalCover.vaps?.filter(vap => vap.id === e)
        }
        if (hadVap === undefined) {
            hadVap = []
        }
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ADD_RAFF_ASSIST,
                vvap: {
                    id: selectedVap.id,
                    icon: selectedVap.icon,
                    title: selectedVap.title,
                    description: selectedVap.description,
                    premium: selectedVap.subtitle,
                    isActive: selectedVap.isActive,
                    quoteCoverId: selectedVap.quoteCoverId,
                    reasonRequired: hadVap.length > 0 ? true : false,
                },
            }
        })
    }
}

export const showRemoveQuoteItem = (carId) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_REMOVE_QUOTE_ITEM,
                removeItemId: carId
            }
        });
    }
}

export const showAddNewItem = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_ADD_NEW_QUOTE_ITEM,
            }
        });
    }
}

export const showBankingDetails = () => {
    return async (dispatch,getState) => {
        await postToController(dispatch, 'GetBankingDetailsQuote', JSON.stringify({
            PolicyId: getState().profile.policyId,
            QuoteId: getState().sales.quoteId
        })).then(async (response) => {
            if (response) {
               await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        bankingDetails: response,
                    }
                })
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        visible: true,
                        type: MODAL_TYPE_SHOW_BANKING,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post GetBankingDetails, Error: " + err);
        })
    }
}

export const showLegalScreen = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_SHOW_LEGAL,
            }
        });
    }
}

export const showInEditScreen = (id,destination) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                id: id,
                destination: destination,
                type: MODAL_TYPE_SHOW_EDIT,
            }
        });
    }
}

export const showQuoteEditScreen = (id, destination) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                id: id,
                destination: destination,
                type: MODAL_TYPE_QUOTE_ITEM_DISCARD,
            }
        });
    }
}

export const showCancelVapPopup = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REQUET_CANCELATION,
            }
        });
    }
}

export const showRequestCancelLifePolicy = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY,
            }
        });
    }
}

export const requestCancellationLife = () => {
    return async (dispatch, getState) => {
        const policy = getState().lifePolicy.policy;
        const lifePolicyDetailsResponse = await postToController(dispatch, 'LifeRequestCancellation', null);
        
        dispatch(showGetBackToYou());
    }
}

export const showGetBackToYou = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_GET_BACK_TO_YOU
            }
        })
    }
}

export const showCancelPolicyEdit = () => {
    return (dispatch, getState) => {
        logEvent('SSP_cancel_update_policy', getState().sales.quoteId + '/' + getState().profile.policyId);
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CANCEL_POLICY_EDIT,
            }
        });
    }
}

export const showAnotherSelfInspection = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ANOTHER_SELF_INSPECTION,
            }
        });
    }
}

export const showSubmitSelfInspection = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_SUBMIT_SELF_INSPECTION,
            }
        });
    }
}

export const showChangeCreditCard = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CHANGE_CREDIT_CARD,
            }
        });
    }
}

export const showSelectedDamageCar = (position) => {    
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: FNOL_SELECTED_DAMAGE_CAR_SHOW,
                position: position
            }
        });
    }
}

export const showSelectedDamageMB = (position) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: FNOL_SELECTED_DAMAGE_MB_SHOW,
                position: position
            }
        });
    }
}

export const showSendContinueOnPhone = (phoneNumber: string, selfInspect = false) => {
    return (dispatch, getState) => {
         dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE,
                continueNumber: phoneNumber,
                isSelfInspect: selfInspect
            }
        });
    }
}

export const showContinueOnPhone = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE,
            }
        });
    }
}

export const showInspectionContinueOnPhone = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE,
            }
        });
    }
}

export const showContinueOnPhoneDifferent = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT,
            }
        });
    }
}

export const showClaimContinueSuccess = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIM_CONTINUE_SUCCESS,
            }
        });
    }
}

export const showInspectionContinueSuccess = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS,
            }
        });
    }
}

export const showDuplicateClaim = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_DUPLICATE_CLAIM,
            }
        });
    }
}

export const showFNOLTakePhoto = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TAKE_FNOL_PHOTOS,
            }
        });
    }
}

export const showSwitchToPhone = (phoneNumber: string) => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE,
                swichToPhoneNumber: phoneNumber
            }
        });
    }
}

export const showSMSsent = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_SMS_SENT,
            }
        });
    }
}

export const showRequestACar = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_REQUEST_A_CAR,
            }
        });
    }
}

export const showEstimatedTime = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIM_ESTIMATED_TIME,
            }
        });
    }
}

export const showEstimatedTimeForEachStep = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP,
            }
        });
    }
}

export const showEstimatedDateChanged = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ESTIMATED_DATE_CHANGED,
            }
        });
    }
}

export const showRepairsTakingLonger = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_REPAIRS_TAKING_LONGER,
            }
        });
    }
}

export const showCostBreakdown = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIM_COST_BREAKDOWN,
            }
        });
    }
}

export const showComfirmIncientAndRisk = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK,
            }
        });
    }
}

export const showRepairsPleaseNote = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE,
            }
        });
    }
}

export const showClaimDisclaimer = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIM_DISCLAIMER,
            }
        });
    }
}

export const showOopsPortablePossessions = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS,
            }
        });
    }
}

export const showCallBackRequest = () => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CALL_BACK_REQUEST,
            }
        });
    }
}

export const showReplacementValueCallMeModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE,
            }
        });
    }
}

export const showOnlyMainlineItemRemovalModal = (itemName) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_QUOTE_MAINLINE_REMOVAL,
                removeItemName : itemName,
            }
        });
    }
}

export const showSendIMEIModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_SEND_IMEI_NUMBER,
            }
        });
    }
}

export const showDrivabeClaimSomeOneElseModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE,
            }
        });
    }
}

export const showDrivabeClaimRecordModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES,
            }
        });
    }
}

export const showDrivabeCloseModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM,
            }
        });
    }
}

export const showRemoveCoverModal = (item, handleToggle) => {
    return (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REMOVE_COVER,
                removeItem: item,
                handleToggleReasons: handleToggle
            }
        });
    }
}

export const showUpdatePolicyModal = (productItem, item) => {
    return (dispatch, getState) => {
        if (getState().profile.selectedPersonalPolicy.canAmendItems) {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_POLICY_VIEW_AMENDMENTS,
                    productType: productItem,
                    filterItem: item,
                }
            });
        }
        else {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL,
                }
            });
        }
    }
}

export const showRetentionsModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REMOVE_LAST_COVER,
            }
        });
    }
}

export const showCellphonePleaseWaitModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CELLPHONE_PLEASE_WAIT,
            }
        });
    }
}

export const showRetentionsWithDependentsModal = (nonMainlineDependents, modalCopy, removeProduct) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS,
                dependents: nonMainlineDependents,
                copy: modalCopy,
                product: removeProduct,
            }
        });
    }
}

export const showCoverRemovedModal = (creditPremium, newPremium, product, description) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REMOVE_COVER_COMPLETE,
                firstPremium: creditPremium,
                totalPremium: newPremium,
                productName: product,
                riskItemDescription: description
            }
        });
    }
}

export const showInEditRemoveScreen = (id, destination) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                id: id,
                destination: destination,
                type: MODAL_TYPE_SHOW_EDIT_REMOVE,
            }
        });
    }
}

export const showRemoveReasons = (e: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_REMOVE_REASONS,
                vap: e,
            }
        })

    }
}

export const showViewInspectionPhoto= (photo) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_VIEW_INSPECTION_PHOTO,
                photo:photo
            }
        });
    }
}

export const showNoLongerMainline = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_NO_LONGER_MAINLINE
            }
        });
    }
}

export const showPoliceReportInfo = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_VIEW_POLICE_REPORT,
            }
        });
    }
}

export const showBlacklistInfo = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_VIEW_BLACKLIST_PHONE,
            }
        });
    }
}

export const showClickawayFollowUp = (id, destination) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                id: id,
                destination: destination,
                type: MODAL_TYPE_CLICK_AWAY,
            }
        });
    }
}

export const showModalClearParty = (partyType: string , reducerName : string) => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_CLEAR_PARTY,
                partyType: partyType,
                reducerName: reducerName
            }
        });
    }
}

export const showClaimsAddressChange = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CLAIMS_ADDRESS_CHANGE
            }
        });
    }
}

export const showSignInModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_SIGN_IN,
            }
        });
    }
}

export const showModalRedirectToZa = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_REDIRECT_ZA
            }
        });
    }
}

export const showModalRedirectToNam = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: MODAL_REDIRECT_NAM,
            }
        });
    }
}

export const showModalExistingClient = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                visible: true,
                type: EXISTING_CLIENT_ERROR,
            }
        });
    }
}